<template>
  <div class="acv-announcements">
    <AuctionAccessBanner
      v-if="showAuctionAccessBanner"
      @banner-button-click="handleUpdateShowAADialog(true)"
    />
    <AcvMobileAnnouncementsCarousel
      v-if="showMobileAnnouncementsCarousel"
      @show-auction-access-banner="handleUpdateShowAADialog(true)"
    />
    <AuctionAccessDialog
      :ref="`auctionAccessIssueDialog-${auctionAccessId}`"
      :show-a-a-dialog="showAuctionAccessDialog"
      :aa-issues="auctionAccessIssues"
      :auction-access-id="auctionAccessId"
      @update:show-a-a-dialog="handleUpdateShowAADialog"
    />
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import useAuctionAccess from '@/composables/useAuctionAccess';
import useAcvAnnouncements from '@/composables/useAcvAnnouncements';
import AuctionAccessBanner from './AuctionAccess/AuctionAccessBanner.vue';
import AuctionAccessDialog from './AuctionAccess/AuctionAccessDialog.vue';
import AcvMobileAnnouncementsCarousel from './MobileAnnouncementsCarousel.vue';

const { auctionAccessIssues, auctionAccessId, hasAuctionAccessIssues } = useAuctionAccess();
const {
  initializeAnnouncements,
  updateAnnouncement,
  removeAnnouncementByKey,
} = useAcvAnnouncements();

const showAuctionAccessDialog = ref(false);

const handleUpdateShowAADialog = (showDialog) => {
  showAuctionAccessDialog.value = showDialog;
};

onMounted(() => {
  initializeAnnouncements();
});

// Watch for changes in auction access issues and update announcements accordingly
watch(hasAuctionAccessIssues, (hasIssues) => {
  if (hasIssues) {
    updateAnnouncement({
      key: 'auction-access-banner',
    });
  } else {
    removeAnnouncementByKey('auction-access-banner');
  }
}, { immediate: false });

defineProps({
  showAuctionAccessBanner: {
    type: Boolean,
    default: false,
  },
  showMobileAnnouncementsCarousel: {
    type: Boolean,
    default: false,
  },
});
</script>
